// extracted by mini-css-extract-plugin
module.exports =  {"author":"_02712f2b3b--author--Yueo2","avatar":"_02712f2b3b--avatar--JdESi","rating":"_02712f2b3b--rating--JHThb","stars":"_02712f2b3b--stars--zTjLF"};